<template>
  <div class="banner">
    <!-- 添加樱花花瓣元素 -->
    <div class="cherry-blossoms">
      <img v-for="n in 30" :key="n" class="cherry-blossom" :class="'wiggle-' + randomWiggle()" :src="randomSakuraImage(n)" :style="randomStyle(n)">
    </div>
    
    <div class="container banner-container">
      <div class="banner-content">
        <div class="logo-title">
          <!-- 移除這個 logo img 標籤 -->
          <!-- <img src="@/assets/logo.png" alt="皆の英語教室" class="site-logo"> -->
          <h1 class="banner-title">{{ heroContent.title || '皆の英語教室' }}</h1>
        </div>
        <h2 class="banner-subtitle">{{ heroContent.subtitle || '楽しく、心を動かす英語教室！' }}</h2>
        <p class="banner-text">{{ heroContent.text || '自信を持って英語を学ぶ。実践的なレッスンで英語力アップ！' }}</p>
        <div class="banner-actions">
          <router-link to="/courses" class="btn btn-primary">{{ heroContent.button1 || 'コースを見る' }}</router-link>
          <router-link to="/contact" class="btn btn-outline">{{ heroContent.button2 || 'お問い合わせ' }}</router-link>
        </div>
      </div>
      <div class="banner-image">
        <img :src="getBannerImageUrl(heroContent.image)" alt="英語教室" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HomeBanner',
  props: {
    heroContent: {
      type: Object,
      default: () => ({
        title: '皆の英語教室',
        subtitle: '楽しく、心を動かす英語教室！',
        text: '自信を持って英語を学ぶ。実践的なレッスンで英語力アップ！',
        button1: 'コースを見る',
        button2: 'お問い合わせ',
        image: ''
      })
    }
  },
  methods: {
    // 获取banner图片URL
    getBannerImageUrl(imageName) {
      if (!imageName) {
        return require('@/assets/banner.png');
      }
      
      // Check if it's a full URL (uploaded image)
      if (imageName.startsWith('http')) {
        return imageName;
      }
      
      // Default assets
      try {
        return require(`@/assets/${imageName}`);
      } catch {
        return require('@/assets/banner.png');
      }
    },
    
    // 生成随机摇摆类型
    randomWiggle() {
      return Math.floor(Math.random() * 3); // 0-2摇摆样式
    },
    
    // 随机选择樱花图片
    randomSakuraImage(index) {
      const imageNum = (index % 5) + 1; // 1-5之间的数字
      return require(`@/assets/sakura/s${imageNum}.png`);
    },
    
    // 生成随机樱花花瓣样式
    randomStyle(index) {
      // 随机大小，不同的花瓣大小不同
      const sizeVariation = Math.random() * 0.4 + 0.4; // 0.4-0.8之间的比例
      const rotate = Math.floor(Math.random() * 360); // 初始旋转角度
      const left = Math.floor(Math.random() * 100); // 0%到100%之间
      
      // 让花瓣从不同的位置开始飘落
      let animationDelay = 0;
      if (index > 15) {
        animationDelay = Math.random() * 10; // 0到10秒之间
      } else {
        // 前15个花瓣几乎立即开始
        animationDelay = Math.random() * 2; // 0-2秒的轻微延迟
      }
      
      const opacity = Math.random() * 0.3 + 0.7; // 0.7到1之间
      const rotationSpeed = Math.random() * 8 + 5; // 5-13秒旋转一周
      
      // 飘落速度
      let fallDuration = 0;
      if (index % 3 === 0) {
        fallDuration = 8 + Math.random() * 8; // 8-16秒飘落(快速)
      } else {
        fallDuration = 12 + Math.random() * 10; // 12-22秒飘落(正常)
      }
      
      // 设置不同的初始位置 - 让更多花瓣从各个方向飘入
      let initialTop = -50;
      let initialLeft = left;
      
      if (index % 5 === 0) {
        // 部分花瓣从左侧飘入
        initialLeft = -10;
        initialTop = Math.floor(Math.random() * 70);
      } else if (index % 5 === 1) {
        // 部分花瓣从右侧飘入
        initialLeft = 110;
        initialTop = Math.floor(Math.random() * 70);
      } else if (index % 5 === 2) {
        // 部分花瓣从中间开始
        initialTop = Math.floor(Math.random() * 50);
      }
      
      return {
        '--scale': sizeVariation,
        '--rotate': `${rotate}deg`,
        '--left': `${initialLeft}%`,
        '--initial-top': `${initialTop}px`,
        '--animation-delay': `${animationDelay}s`,
        '--opacity': opacity,
        '--rotation-speed': `${rotationSpeed}s`,
        '--fall-duration': `${fallDuration}s`
      };
    }
  }
}
</script>

<style scoped>
.banner {
  /* 恢复之前的浅粉色背景 */
  /* background: linear-gradient(135deg, var(--accent-color) 0%, var(--secondary-color) 100%); */
  background-color: var(--banner-bg-color, #fff0f5); /* LavenderBlush - a light pink */
  padding: 80px 0;
  overflow: hidden;
  position: relative;
}

/* Logo和标题样式 */
.logo-title {
  display: flex;
  align-items: center;
  margin-bottom: 15px;
  /* 移除 justify-content: center; 使标题左对齐 */
  /* justify-content: center; */
}

/* 移除 .site-logo 样式 */
/*
.site-logo {
  height: 50px;
  width: auto;
  margin-right: 10px;
}
*/

/* 樱花飘落动画 */
.cherry-blossoms {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  z-index: 1;
  pointer-events: none;
}

.cherry-blossom {
  position: absolute;
  top: var(--initial-top, -50px);
  left: var(--left);
  opacity: var(--opacity);
  transform-origin: center;
  transform: scale(var(--scale)) rotate(var(--rotate));
  animation-delay: var(--animation-delay);
  animation-timing-function: linear;
  animation-iteration-count: infinite;
  z-index: 1;
  width: 40px; /* 基本大小，会被缩放 */
  height: auto;
  filter: drop-shadow(0 0 3px rgba(255, 255, 255, 0.3));
}

/* 给每个摇摆类型应用不同的动画 */
.cherry-blossom.wiggle-0 {
  animation-name: sakura-breeze-1, rotate-clockwise;
}

.cherry-blossom.wiggle-1 {
  animation-name: sakura-breeze-2, rotate-counterclockwise;
}

.cherry-blossom.wiggle-2 {
  animation-name: sakura-breeze-3, rotate-clockwise;
}

/* 花瓣旋转动画的持续时间 */
.cherry-blossom {
  animation-duration: var(--fall-duration), var(--rotation-speed);
}

/* 微风吹拂樱花动画1 - 平缓起伏 */
@keyframes sakura-breeze-1 {
  0% {
    top: var(--initial-top, -50px);
    left: var(--left);
    transform: scale(var(--scale)) translateX(0) translateY(0) rotate(var(--rotate));
  }
  10% {
    transform: scale(var(--scale)) translateX(20px) translateY(10px) rotate(var(--rotate));
  }
  20% {
    transform: scale(var(--scale)) translateX(-10px) translateY(30px) rotate(var(--rotate));
  }
  30% {
    transform: scale(var(--scale)) translateX(15px) translateY(50px) rotate(var(--rotate));
  }
  40% {
    transform: scale(var(--scale)) translateX(-25px) translateY(60px) rotate(var(--rotate));
  }
  50% {
    transform: scale(var(--scale)) translateX(10px) translateY(120px) rotate(var(--rotate));
  }
  60% {
    transform: scale(var(--scale)) translateX(-20px) translateY(180px) rotate(var(--rotate));
  }
  70% {
    transform: scale(var(--scale)) translateX(30px) translateY(220px) rotate(var(--rotate));
  }
  80% {
    transform: scale(var(--scale)) translateX(-15px) translateY(250px) rotate(var(--rotate));
  }
  90% {
    transform: scale(var(--scale)) translateX(10px) translateY(280px) rotate(var(--rotate));
  }
  100% {
    top: calc(100% + 50px);
    left: var(--left);
    transform: scale(var(--scale)) translateX(0) translateY(0) rotate(var(--rotate));
  }
}

/* 微风吹拂樱花动画2 - 水平摆动大 */
@keyframes sakura-breeze-2 {
  0% {
    top: var(--initial-top, -50px);
    left: var(--left);
    transform: scale(var(--scale)) translateX(0) translateY(0) rotate(var(--rotate));
  }
  15% {
    transform: scale(var(--scale)) translateX(50px) translateY(20px) rotate(calc(var(--rotate) + 15deg));
  }
  30% {
    transform: scale(var(--scale)) translateX(-30px) translateY(60px) rotate(calc(var(--rotate) - 15deg));
  }
  45% {
    transform: scale(var(--scale)) translateX(70px) translateY(150px) rotate(calc(var(--rotate) + 20deg));
  }
  60% {
    transform: scale(var(--scale)) translateX(-40px) translateY(180px) rotate(calc(var(--rotate) - 10deg));
  }
  75% {
    transform: scale(var(--scale)) translateX(30px) translateY(220px) rotate(calc(var(--rotate) + 10deg));
  }
  85% {
    transform: scale(var(--scale)) translateX(-20px) translateY(260px) rotate(calc(var(--rotate) - 5deg));
  }
  100% {
    top: calc(100% + 50px);
    left: var(--left);
    transform: scale(var(--scale)) translateX(0) translateY(0) rotate(var(--rotate));
  }
}

/* 微风吹拂樱花动画3 - 有悬浮感 */
@keyframes sakura-breeze-3 {
  0% {
    top: var(--initial-top, -50px);
    left: var(--left);
    transform: scale(var(--scale)) translateX(0) translateY(0) rotate(var(--rotate));
  }
  10% {
    transform: scale(var(--scale)) translateX(30px) translateY(10px) rotate(calc(var(--rotate) + 10deg));
  }
  20% {
    transform: scale(var(--scale)) translateX(-15px) translateY(30px) rotate(calc(var(--rotate) - 20deg));
  }
  30% {
    transform: scale(var(--scale)) translateX(20px) translateY(50px) rotate(calc(var(--rotate) + 5deg));
  }
  40% {
    transform: scale(var(--scale)) translateX(-25px) translateY(70px) rotate(calc(var(--rotate) - 15deg));
  }
  50% {
    transform: scale(var(--scale)) translateX(40px) translateY(110px) rotate(calc(var(--rotate) + 15deg));
  }
  60% {
    transform: scale(var(--scale)) translateX(-10px) translateY(160px) rotate(calc(var(--rotate) - 10deg));
  }
  70% {
    transform: scale(var(--scale)) translateX(25px) translateY(210px) rotate(calc(var(--rotate) + 20deg));
  }
  80% {
    transform: scale(var(--scale)) translateX(-30px) translateY(260px) rotate(calc(var(--rotate) - 5deg));
  }
  90% {
    transform: scale(var(--scale)) translateX(15px) translateY(300px) rotate(calc(var(--rotate) + 10deg));
  }
  100% {
    top: calc(100% + 50px);
    left: var(--left);
    transform: scale(var(--scale)) translateX(0) translateY(0) rotate(var(--rotate));
  }
}

/* 花瓣旋转 */
@keyframes rotate-clockwise {
  from { transform: scale(var(--scale)) rotate(0deg); }
  to { transform: scale(var(--scale)) rotate(360deg); }
}

@keyframes rotate-counterclockwise {
  from { transform: scale(var(--scale)) rotate(0deg); }
  to { transform: scale(var(--scale)) rotate(-360deg); }
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 15px;
  position: relative;
  z-index: 2; /* 确保内容在花瓣之上 */
}

.banner-container {
  display: flex;
  align-items: center;
  justify-content: space-between; /* 恢复左右布局 */
  gap: 40px;
  position: relative; /* 确保 z-index 生效 */
  z-index: 2; /* 内容在花瓣上 */
}

.banner-content {
  flex: 1;
  /* 恢复之前的 padding-right */
  padding-right: 40px;
  /* 恢复文字颜色 */
  color: initial; /* 重置颜色，让子元素继承默认或各自设置 */
  text-shadow: none; /* 移除白色文字的阴影 */
  max-width: 600px; /* 限制最大宽度 */
}

.banner-title {
  /* 恢复原来的字体大小和颜色 */
  font-size: 42px;
  font-weight: bold;
  color: var(--primary-color); /* 使用主色调 */
  margin: 0;
}

.banner-subtitle {
  /* 恢复原来的字体大小和颜色 */
  font-size: 28px;
  color: #333; /* 深灰色 */
  margin: 15px 0 20px; /* 调整 margin */
  font-weight: 600;
}

.banner-text {
  /* 恢复原来的字体大小和颜色 */
  font-size: 18px;
  color: #555; /* 稍浅的灰色 */
  margin-bottom: 30px;
  line-height: 1.6; /* 恢复行高 */
  opacity: 1; /* 恢复不透明度 */
}

.banner-actions {
  /* 恢复 flex 布局和间距 */
  display: flex;
  gap: 15px;
}

/* 恢复之前的按钮基础样式 */
.btn {
  padding: 12px 25px;
  border-radius: 25px; /* 圆角 */
  text-decoration: none;
  font-weight: bold;
  transition: all 0.3s ease;
  display: inline-block;
  border: none;
  cursor: pointer;
  font-size: 16px; /* 恢复字体大小 */
}

/* 恢复 .btn-primary 样式 */
.btn-primary {
  background-color: var(--primary-color);
  color: white;
}
.btn-primary:hover {
  background-color: var(--secondary-color);
  transform: translateY(-2px);
}

/* 恢复 .btn-outline 样式 */
.btn-outline {
  background-color: transparent;
  border: 2px solid var(--primary-color);
  color: var(--primary-color);
}
.btn-outline:hover {
  background-color: var(--primary-color);
  color: white;
}

.banner-image {
  flex: 1;
  max-width: 500px; /* 恢复图片容器大小 */
  display: flex; /* 确保 flex 布局 */
  justify-content: center;
  align-items: center;
}

.banner-image img {
  max-width: 100%;
  height: auto;
  border-radius: 15px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1); /* 恢复阴影 */
  /* 恢复浮动动画 */
  animation: float 3s ease-in-out infinite;
}

/* 恢复浮动动画 */
@keyframes float {
  0% {
    transform: translateY(0px);
  }
  50% {
    transform: translateY(-10px);
  }
  100% {
    transform: translateY(0px);
  }
}

/* 恢复媒体查询中的样式 */
@media (max-width: 992px) {
  .banner {
    padding: 60px 0;
  }
  .banner-container {
    flex-direction: column;
    text-align: center;
  }
  .banner-content {
    padding-right: 0; /* 移除平板及以下尺寸的右边距 */
    margin-bottom: 40px;
    max-width: 100%;
  }
   .logo-title {
     justify-content: center; /* 移动端标题居中 */
   }
   .banner-actions {
     justify-content: center; /* 移动端按钮居中 */
   }
  .banner-title {
    font-size: 32px;
  }
  .banner-subtitle {
    font-size: 20px;
  }
  .banner-text {
    font-size: 16px;
  }
  .banner-image {
    max-width: 80%;
  }
  /* 减少樱花数量 */
  .cherry-blossom:nth-child(n+16) {
    display: none;
  }
}

@media (max-width: 768px) {
  .banner-title {
    font-size: 28px;
  }
  .banner-subtitle {
    font-size: 18px;
  }
  .banner-text {
    font-size: 15px;
  }
  .banner-actions .btn {
    margin-right: 10px; /* 减小按钮间距 */
    padding: 10px 20px;
    font-size: 14px;
  }
  .banner-image {
    max-width: 90%;
  }
   .cherry-blossom {
     width: 30px; /* 移动端花瓣稍小 */
   }
  /* 进一步减少樱花 */
  .cherry-blossom:nth-child(n+11) {
      display: none;
  }
}
</style> 